import { ResidentAppError } from '../../common/error'

/**
 * Whether a region of the page (a card, the aside) may show the error in
 * place with a retry button.
 *
 * Every `ResidentAppError` is left to the layout's own error boundaries, as
 * before: they include the expired session, denied access, write access
 * denials and API errors whose error page shows a code-specific message,
 * action or event id. Regions catch the rest, e.g. network failures, a lazy
 * chunk that failed to load or a rendering bug.
 */
export const shouldRegionCatchError = (error: unknown): boolean =>
  !(error instanceof ResidentAppError)
